import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'px-combined-copy-details',
  host: {
    class: 'flex flex-col'
  },
  template: `
    <p mxTruncate>{{ collection }}</p>
    <p mxTruncate>{{ callNumber }}</p>
    <p mxTruncate>{{ shelfLocation }}</p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TruncateDirective]
})
export class CombinedCopyDetailsComponent {
  @Input({required: true}) collection: string;
  @Input({required: true}) callNumber: string;
  @Input({required: true}) shelfLocation: string;
}
